import { uploadImageCallback } from './imageUpload';

const colorPalette = [
  'rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
  'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
  'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(247,218,100)',
  'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)', 'rgb(239,239,239)',
  'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)', 'rgb(184,49,47)',
  'rgb(124,112,107)', 'rgb(209,213,216)', 'rgb(255,255,0)', 'rgb(255,192,0)', 'rgb(255,0,0)',
  'rgb(128,0,128)', 'rgb(0,255,0)', 'rgb(0,128,0)'
];

const imageConfig = {
  uploadCallback: uploadImageCallback,
  alt: { present: true, mandatory: false },
  previewImage: true,
  inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
  defaultSize: {
    height: 'auto',
    width: '350',
  },
};

// Full toolbar for question text and explanation
export const questionTextToolbar = {
  options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'image', 'history'],
  inline: { options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'] },
  colorPicker: { colors: colorPalette },
  image: imageConfig,
};

// Same as questionText
export const explanationToolbar = questionTextToolbar;

// Compact toolbar for answer choices
export const choiceToolbar = {
  options: ['inline', 'list', 'colorPicker', 'link', 'image', 'history'],
  inline: { options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'] },
  colorPicker: { colors: colorPalette },
  image: imageConfig,
};

// Minimal toolbar for lesson reference
export const lessonReferenceToolbar = {
  options: ['inline', 'list', 'colorPicker', 'link', 'image'],
  inline: { options: ['bold', 'italic', 'underline', 'strikethrough'] },
  colorPicker: { colors: colorPalette },
  image: imageConfig,
};

// Same as questionText (for passage editor)
export const passageToolbar = questionTextToolbar;

// Shared CSS for editor containers
export const editorContainerStyles = `
  .question-editor-container .rdw-editor-main,
  .choice-editor-container .rdw-editor-main,
  .explanation-editor-container .rdw-editor-main,
  .lesson-editor-container .rdw-editor-main,
  .passage-editor-container .rdw-editor-main {
    overflow-x: hidden !important;
    background-color: #fff !important;
    padding: 0 12px !important;
    min-height: 120px !important;
  }
  .question-editor-container .DraftEditor-root,
  .question-editor-container .DraftEditor-editorContainer,
  .question-editor-container .public-DraftEditor-content,
  .choice-editor-container .DraftEditor-root,
  .choice-editor-container .DraftEditor-editorContainer,
  .choice-editor-container .public-DraftEditor-content,
  .explanation-editor-container .DraftEditor-root,
  .explanation-editor-container .DraftEditor-editorContainer,
  .explanation-editor-container .public-DraftEditor-content,
  .lesson-editor-container .DraftEditor-root,
  .lesson-editor-container .DraftEditor-editorContainer,
  .lesson-editor-container .public-DraftEditor-content,
  .passage-editor-container .DraftEditor-root,
  .passage-editor-container .DraftEditor-editorContainer,
  .passage-editor-container .public-DraftEditor-content {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
  .question-editor-container .public-DraftEditor-content figure,
  .question-editor-container .public-DraftEditor-content img,
  .choice-editor-container .public-DraftEditor-content figure,
  .choice-editor-container .public-DraftEditor-content img,
  .explanation-editor-container .public-DraftEditor-content figure,
  .explanation-editor-container .public-DraftEditor-content img,
  .lesson-editor-container .public-DraftEditor-content figure,
  .lesson-editor-container .public-DraftEditor-content img,
  .passage-editor-container .public-DraftEditor-content figure,
  .passage-editor-container .public-DraftEditor-content img {
    max-width: 100% !important;
    height: auto !important;
  }
  .question-editor-container .public-DraftEditor-content div,
  .choice-editor-container .public-DraftEditor-content div,
  .explanation-editor-container .public-DraftEditor-content div,
  .lesson-editor-container .public-DraftEditor-content div,
  .passage-editor-container .public-DraftEditor-content div {
    word-break: break-word !important;
    overflow-wrap: break-word !important;
  }
`;
